// 간편결제 복귀 신호 수신부 (BRIDGE_PROTOCOL §2.3).
//
// native 가 ${APP_SCHEME}://payment/return 복귀(또는 iOS SFSafariVC Done) 시 window.onEasyPayReturn({orderId}) 를
// 호출한다. 반드시 window 에 직접 등록해야 native 가 찾는다(ES module 지역 함수는 silent drop — bridgeError.ts 와
// 동일 패턴). iOS 는 미정의 시 didFinish 버퍼로 재전달하므로 앱 로드 시점(App)에서 1회 등록한다.
//
// payload 는 orderId 단일(결과 판정 없음) — 확정은 web 폴링. examId 는 콜백에 없으므로,
// 수신 측이 in-flight(localStorage)에서 orderId 로 examId 를 매칭한다.

export const registerEasyPayReturnHandler = (
  onSignal: (orderId: string) => void,
): (() => void) => {
  const handler: NonNullable<Window["onEasyPayReturn"]> = ({ orderId }) => {
    if (typeof orderId === "string" && orderId.length > 0) onSignal(orderId);
  };

  window.onEasyPayReturn = handler;

  return () => {
    // 등록 이후 다른 곳에서 덮어쓰지 않았을 때만 정리한다.
    if (window.onEasyPayReturn === handler) {
      delete window.onEasyPayReturn;
    }
  };
};

// ────────────────────────────────────────────────────────────
// in-place consumer 슬롯 (warm/cold 통일)
//
// onEasyPayReturn 은 계약상 "프로세스 생존(warm)" 복귀 신호다. 결제 스텝이 살아있으면
// (useEasyPayReturnReconcile 가 active) 이 슬롯에 소비자를 등록하고, goToPaymentReturn 이
// 그 유무로 warm(그 자리 처리) vs cold(location.assign 리로드) 를 분기한다.
// - iOS 취소(SFSafariVC Done) 신호도 여기로 흘러 리로드 대신 in-place 처리 → AOS 와 동작 통일.
// - 스텝 미마운트(cold-start 등)면 소비자 부재 → 기존 location.assign 폴백.
// window.onEasyPayReturn 슬롯(위)과 별개의 module-level 슬롯이라 서로 간섭하지 않는다.
let inPlaceConsumer: ((orderId: string) => void) | null = null;

/** 결제 스텝 active 동안 in-place 소비자를 등록한다. 반환 클로저로 해제(자기 것만 — 토큰 가드). */
export const setEasyPayInPlaceConsumer = (
  fn: (orderId: string) => void,
): (() => void) => {
  inPlaceConsumer = fn;
  return () => {
    if (inPlaceConsumer === fn) inPlaceConsumer = null;
  };
};

/** goToPaymentReturn 이 warm/cold 분기 판단에 쓴다. */
export const getEasyPayInPlaceConsumer = (): ((orderId: string) => void) | null =>
  inPlaceConsumer;
